module.exports = __webpack_public_path__ + "static/pitcrew-bikes-863a335edae6d0d8da1ed244b7537fbd.png";